import React from 'react';
import CheckCircleRounded from '@mui/icons-material/CheckCircleRounded';
import { Box, TextField, Typography } from '@mui/material';

import Button from '../Button';
import { v2Colors } from '../../design/theme';
import {
  LOYALTY_OTP_MAX_LENGTH,
  isLoyaltyOtpComplete,
  normalizeLoyaltyOtp,
} from '../../services/commerce';

const linkButtonSx = {
  border: 'none',
  bgcolor: 'transparent',
  p: 0,
  fontFamily: 'inherit',
  fontSize: '0.8rem',
  fontWeight: 700,
  color: v2Colors.primary,
  textDecoration: 'underline',
  cursor: 'pointer',
  '&:disabled': { color: v2Colors.textMuted, cursor: 'not-allowed', textDecoration: 'none' },
};

export default function LoyaltyOtpField({
  sentTo,
  value,
  onChange,
  onConfirm,
  onResend,
  confirmed,
  discount,
  resending,
  disabled,
}) {
  if (confirmed) {
    return (
      <Box sx={{ mt: 1.25, display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <CheckCircleRounded sx={{ fontSize: 18, color: v2Colors.success }} />
        <Typography variant="body2" sx={{ color: v2Colors.success, fontWeight: 700 }}>
          ₹{discount} off applied
        </Typography>
      </Box>
    );
  }

  const canConfirm = isLoyaltyOtpComplete(value) && !disabled && !resending;

  return (
    <Box sx={{ mt: 1.25 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          mb: 0.75,
        }}
      >
        <Typography variant="caption" sx={{ color: v2Colors.heading, lineHeight: 1.3 }}>
          {sentTo ? `OTP sent to ${sentTo}` : 'OTP sent to your mobile'}
        </Typography>
        <Box
          component="button"
          type="button"
          disabled={disabled || resending}
          onClick={onResend}
          sx={linkButtonSx}
        >
          {resending ? 'Sending…' : 'Resend OTP'}
        </Box>
      </Box>
      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          if (canConfirm) onConfirm();
        }}
        sx={{ display: 'flex', alignItems: 'stretch', gap: 1 }}
      >
        <TextField
          value={value}
          placeholder="Enter OTP"
          size="small"
          disabled={disabled || resending}
          onChange={(e) => onChange(normalizeLoyaltyOtp(e.target.value))}
          inputProps={{
            inputMode: 'numeric',
            maxLength: LOYALTY_OTP_MAX_LENGTH,
            autoComplete: 'one-time-code',
            'aria-label': 'Naatu points OTP',
            style: { letterSpacing: '0.2em', fontWeight: 600 },
          }}
          sx={{
            flex: 1,
            '& .MuiOutlinedInput-root': {
              bgcolor: v2Colors.white,
              borderRadius: 2,
              '& fieldset': { borderColor: v2Colors.borderMuted },
              '&.Mui-focused fieldset': { borderColor: v2Colors.primary },
            },
          }}
        />
        <Button
          type="submit"
          disabled={!canConfirm}
          sx={{
            flexShrink: 0,
            borderRadius: 2,
            px: 2.25,
            fontWeight: 700,
            bgcolor: v2Colors.primary,
            color: v2Colors.white,
            '&:hover': { bgcolor: v2Colors.primaryDark },
            '&.Mui-disabled': { bgcolor: v2Colors.borderMuted, color: v2Colors.white },
          }}
        >
          Confirm
        </Button>
      </Box>
    </Box>
  );
}
